/**
 * Recipes MV2 QueryClient singleton.
 */
import { makeMv2QueryClient } from "@/features/_mv2/makeQueryClient";
import { setupMv2CachePersist } from "@/features/_mv2/mv2CachePersist";
import {
  RECIPES_QUERY_KEY,
  DRY_CAKES_QUERY_KEY,
  CHEESECAKES_QUERY_KEY,
  RTG_STOCK_QUERY_KEY,
  INGREDIENT_CATALOG_QUERY_KEY,
  fetchRecipesFromApi,
  fetchDryCakesFromApi,
  fetchCheesecakesFromApi,
  fetchRtgStockFromApi,
  fetchIngredientCatalogFromApi,
} from "./recipesQueryApi";

export const recipesQueryClient = makeMv2QueryClient();
setupMv2CachePersist(recipesQueryClient, "recipes");

export function prefetchRecipes() {
  return Promise.all([
    recipesQueryClient.prefetchQuery({
      queryKey: [RECIPES_QUERY_KEY],
      queryFn: ({ signal }) => fetchRecipesFromApi(signal),
    }),
    recipesQueryClient.prefetchQuery({
      queryKey: [DRY_CAKES_QUERY_KEY],
      queryFn: ({ signal }) => fetchDryCakesFromApi(signal),
    }),
    recipesQueryClient.prefetchQuery({
      queryKey: [CHEESECAKES_QUERY_KEY],
      queryFn: ({ signal }) => fetchCheesecakesFromApi(signal),
    }),
    recipesQueryClient.prefetchQuery({
      queryKey: [RTG_STOCK_QUERY_KEY],
      queryFn: ({ signal }) => fetchRtgStockFromApi(signal),
    }),
    recipesQueryClient.prefetchQuery({
      queryKey: [INGREDIENT_CATALOG_QUERY_KEY],
      queryFn: ({ signal }) => fetchIngredientCatalogFromApi(signal),
    }),
  ]);
}
